import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Box, 
  Drawer, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText,
  Typography 
} from '@mui/material';
import { 
  Home,
  Store,
  Package,
  Boxes,
  ShoppingCart,
  Send,
  Lock,
  TrendingUp,
  BarChart2,
  AArrowDownIcon,
  FileText,
  Users,
  HandCoins
} from 'lucide-react';
import { AuthContext } from '../contexts/AuthContext';

const drawerWidth = 240;

const menuItems = [
  { text: 'Dashboard', icon: <Home size={20} />, path: '/' },
  { text: 'Duka', icon: <Store size={20} />, path: '/dukas' },
  { text: 'Product', icon: <Package size={20} />, path: '/products' },
  { text: 'Stock', icon: <Boxes size={20} />, path: '/stock' },
  { text: 'Duka Stock', icon: <Send size={20} />, path: '/duka-stock' },
  { text: 'Order', icon: <ShoppingCart size={20} />, path: '/orders' },
  { text: 'Sales', icon: <HandCoins size={20} />, path: '/sales' },
  { text: 'Projection', icon: <TrendingUp size={20} />, path: '/projections' },
  // { text: 'Adjustment Level', icon: <AArrowDownIcon size={20} />, path: '/adjustment-levels' },
  // { text: 'Service Level', icon: <BarChart2 size={20} />, path: '/service-levels' },
  { text: 'Amendments', icon: <FileText size={20} />, path: '/amendments' },
  { text: 'User Management', icon: <Users size={20} />, path: '/user-management' }
];

const Sidebar = ({ open }) => {
  const location = useLocation();
  const { user } = useContext(AuthContext);

  const filteredMenuItems = (() => {
    if (user?.role?.name === 'AREA_COORDINATOR') {
      return menuItems.filter(item =>
        item.text === 'Duka' ||
        item.text === 'Order' ||
        item.text === 'Amendments'
      );
    } else if (user?.role?.name === 'LOGISTICS_COORDINATOR') {
      return menuItems.filter(item =>
        item.text === 'Duka' ||
        item.text === 'Stock'
      );
    } else {
      return menuItems;
    }
  })();

  return (
    <Drawer
      variant={open ? 'permanent' : 'temporary'}
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          bgcolor: '#124F3E',
          color: 'white',
          borderRight: 'none',
        },
      }}
      open={open} // Control visibility
      onClose={() => {}}
    >
      <Box sx={{ p: 2 }}>
        <Typography variant="subtitle1" sx={{ color: 'white', fontWeight: 600 }}>
          Quick Links
        </Typography>
      </Box>
      <List>
        {filteredMenuItems.map((item) => (
          <ListItem
            key={item.text}
            component={Link}
            to={item.path}
            selected={location.pathname === item.path}
            sx={{
              py: 1,
              color: 'white',
              '&.Mui-selected': {
                bgcolor: 'rgba(255, 255, 255, 0.1)',
              },
              '&:hover': {
                bgcolor: 'rgba(255, 255, 255, 0.05)',
              },
            }}
          >
            <ListItemIcon sx={{ color: 'white', minWidth: 40 }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText 
              primary={item.text} 
              primaryTypographyProps={{ 
                fontSize: '0.875rem',
                fontWeight: location.pathname === item.path ? 600 : 400
              }} 
            />
          </ListItem>
        ))}
      </List>
    </Drawer>
  );
};

export default Sidebar;